/** Every v2 route in one place, so a link and its route can not drift apart. */

const seg = (value: string) => encodeURIComponent(value);

const envBase = (customer: string, environment: string) => `/v2/env/${seg(customer)}/${seg(environment)}`;

export const v2 = {
    home: () => '/v2',
    environments: () => '/v2/omgevingen',
    issues: (tab?: 'deploy') => (tab ? `/v2/issues?tab=${tab}` : '/v2/issues'),
    /** One issue, as a panel over the issues tab of its environment: the frame (heading, Exact meters) stays. */
    issue: (customer: string, environment: string, key: string) => `${envBase(customer, environment)}/issues/${seg(key)}`,
    /** One issue as a panel over the issues of every environment, for the overview page. */
    globalIssue: (customer: string, environment: string, key: string) =>
        `/v2/issue/${seg(customer)}/${seg(environment)}/${seg(key)}`,
    deploy: (deployId?: string) => (deployId ? `/v2/deploy/${seg(deployId)}` : '/v2/deploy'),
    /** Exact usage across environments; with one picked, it is selected in the list. */
    exact: (customer?: string, environment?: string) =>
        customer && environment ? `/v2/exact/${seg(customer)}/${seg(environment)}` : '/v2/exact',
    scenarios: () => '/v2/scenarios',
    run: (customer: string, environment: string, runId: string) =>
        `/v2/scenarios/${seg(customer)}/${seg(environment)}/${seg(runId)}`,
    /** A path per tab, not a query string: the rail marks the one that is open. */
    learn: (tab?: 'mails') => (tab ? '/v2/leren/klantmails' : '/v2/leren'),
    env: envBase,
    envIssues: (customer: string, environment: string) => `${envBase(customer, environment)}/issues`,
    monitor: (customer: string, environment: string) => `${envBase(customer, environment)}/monitor`,
    errorLog: (customer: string, environment: string) => `${envBase(customer, environment)}/foutenlogboek`,
    envExact: (customer: string, environment: string) => `${envBase(customer, environment)}/exact`,
    /** The dossier and timeline of one object: an invoice, payment, credit note or customer, by its id. */
    object: (customer: string, environment: string, id: string) => `${envBase(customer, environment)}/object/${seg(id)}`,
};
